import { useState } from "react";

export default function ShareButton({ title }: { title: string }) {
  const [tip, setTip] = useState("");

  const fallbackCopy = (text: string) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
    } catch {
      // 忽略复制失败
    }
    document.body.removeChild(textarea);
  };

  const handleShare = async () => {
    const url = window.location.href;
    try {
      if (typeof navigator.share === "function") {
        await navigator.share({ title, url });
        return;
      }
    } catch {
      return;
    }
    try {
      await navigator.clipboard.writeText(url);
      setTip("链接已复制");
    } catch {
      fallbackCopy(url);
      setTip("链接已复制");
    }
    window.setTimeout(() => setTip(""), 2200);
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={handleShare}
        className="inline-flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm font-medium text-foreground-800 hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-share-line w-4 h-4 flex items-center justify-center"></i>
        分享
      </button>
      {tip && (
        <span className="absolute left-1/2 -translate-x-1/2 top-full mt-2 whitespace-nowrap rounded-md bg-foreground-950 px-3 py-1.5 text-xs text-background-50 animate-banana-fade">
          {tip}
        </span>
      )}
    </div>
  );
}